import { useAppSelector } from 'shared';

export const useSweetShopArticlesPageState = (
    () => useAppSelector((store) => store.sweetShopArticlesPage)
);
